var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeanTo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2039_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5091 39.3169C93.6354 39.7554 93.7032 40.2185 93.7032 40.6976C93.7032 43.4444 91.4765 45.671 88.7298 45.671C85.9829 45.671 83.7563 43.4442 83.7563 40.6976C83.7563 38.6019 85.0526 36.8089 86.887 36.0767",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7293 55.618C91.4761 55.618 93.7027 53.3913 93.7027 50.6446C93.7027 47.8978 91.4761 45.6711 88.7293 45.6711C85.9825 45.6711 83.7559 47.8978 83.7559 50.6446C83.7559 53.3913 85.9825 55.618 88.7293 55.618Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7293 65.565C91.4761 65.565 93.7027 63.3384 93.7027 60.5916C93.7027 57.8448 91.4761 55.6182 88.7293 55.6182C85.9825 55.6182 83.7559 57.8448 83.7559 60.5916C83.7559 63.3384 85.9825 65.565 88.7293 65.565Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7293 75.5123C91.4761 75.5123 93.7027 73.2856 93.7027 70.5389C93.7027 67.7921 91.4761 65.5654 88.7293 65.5654C85.9825 65.5654 83.7559 67.7921 83.7559 70.5389C83.7559 73.2856 85.9825 75.5123 88.7293 75.5123Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5281 83.1488C84.0391 82.3789 83.7559 81.4654 83.7559 80.4859C83.7559 77.739 85.9826 75.5125 88.7293 75.5125C91.4762 75.5125 93.7027 77.7392 93.7027 80.4859C93.7027 81.1726 93.5635 81.8267 93.3119 82.4218",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9689 36.0217C14.8793 36.7159 16.2439 38.5473 16.2439 40.6977C16.2439 43.4446 14.0172 45.6711 11.2705 45.6711C8.52383 45.6711 6.29688 43.4444 6.29688 40.6977C6.29688 40.2524 6.35547 39.8208 6.46523 39.41",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2703 55.618C14.0171 55.618 16.2437 53.3913 16.2437 50.6446C16.2437 47.8978 14.0171 45.6711 11.2703 45.6711C8.52356 45.6711 6.29688 47.8978 6.29688 50.6446C6.29688 53.3913 8.52356 55.618 11.2703 55.618Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2703 65.565C14.0171 65.565 16.2437 63.3384 16.2437 60.5916C16.2437 57.8448 14.0171 55.6182 11.2703 55.6182C8.52356 55.6182 6.29688 57.8448 6.29688 60.5916C6.29688 63.3384 8.52356 65.565 11.2703 65.565Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2703 75.5123C14.0171 75.5123 16.2437 73.2856 16.2437 70.5389C16.2437 67.7921 14.0171 65.5654 11.2703 65.5654C8.52356 65.5654 6.29688 67.7921 6.29688 70.5389C6.29688 73.2856 8.52356 75.5123 11.2703 75.5123Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92715 82.9111C6.52559 82.1937 6.29688 81.3666 6.29688 80.4859C6.29688 77.739 8.52363 75.5125 11.2703 75.5125C14.017 75.5125 16.2437 77.7392 16.2437 80.4859C16.2437 81.2947 16.0508 82.0584 15.7082 82.7334",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.493 38.7298L50.6995 17.7718C50.2585 17.5558 49.7422 17.5558 49.301 17.7718L6.50748 38.7298C5.719 39.1159 4.76685 38.7897 4.38052 38.0013L2.30494 33.7628C1.91881 32.9743 2.24498 32.0222 3.03345 31.6358L49.301 8.97646C49.742 8.76045 50.2583 8.76045 50.6995 8.97646L96.967 31.636C97.7555 32.0222 98.0817 32.9743 97.6956 33.7628L95.62 38.0011C95.2338 38.7897 94.2815 39.1159 93.493 38.7298Z",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3154 91.1856H2.32656C1.85059 91.1856 1.46484 90.7999 1.46484 90.3239V84.1493C1.46484 83.6733 1.85059 83.2876 2.32656 83.2876H97.6734C98.1494 83.2876 98.5352 83.6733 98.5352 84.1493V90.3239C98.5352 90.7999 98.1494 91.1856 97.6734 91.1856H72.1514",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9194 40.9798L83.7562 40.6978",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2891 41.0813L34.8879 40.9797",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0127 77.6258L83.8494 77.3438",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3828 77.7275L34.9816 77.626",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1719 33.0168H81.8277",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 71.2891H81.8199",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.335 24.7935H35.665",
    stroke: "#7A297F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2039_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeanTo);
export default __webpack_public_path__ + "static/media/lean-to.5acc9f0650647b27f8526ff35a52d2f4.svg";
export { ForwardRef as ReactComponent };